import type { ObservationDetail } from "@/entities/observation";

import {
  useGetObservationComments,
  useGetObservationWithDatasets,
} from "@/entities/observation";
import { useGetRecommendationInterventions } from "@/entities/recommendation";

import { getObservationRelatedItemsTypes } from "./observation-delete-related-items.helper";

export const useObservationDeleteRelatedItems = (
  observation: ObservationDetail
) => {
  const recommendation = observation.recommendation ?? undefined;

  const { datasets, isLoading: isDatasetsLoading } =
    useGetObservationWithDatasets(observation.id);

  const { comments, isLoading: isCommentsLoading } =
    useGetObservationComments(observation);

  const { recommendedInterventions, isLoading: isInterventionsLoading } =
    useGetRecommendationInterventions({
      recommendationId: recommendation?.id ?? 0,
    });

  const isLoading =
    isDatasetsLoading || isCommentsLoading || isInterventionsLoading;

  const itemsTypes = getObservationRelatedItemsTypes({
    datasets,
    comments,
    recommendation,
    interventions: recommendedInterventions,
  });

  return {
    itemsTypes,
    isLoading,
  };
};
